// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1IQHQ","infoBtn":"quickbooks_infoBtn__2tcci","formBox":"quickbooks_formBox__1Y2h3","formFooter":"quickbooks_formFooter__2z814"};